<template>
  <nx-fullscreen-dialog :title="liveTitle" :active="active" @dismiss="dismiss">
    <v-btn
      slot="toolbar-items"
      color="accent"
      flat
      :disabled="!isValid"
      @click="insertBlot"
    >{{ buttonTitle }}</v-btn>
    <template>
      <v-container grid-list-xs pb-3>
        <v-layout>
          <v-flex offset-md2 md8 pt-4>
            <h2 class="nx-block-headline">{{ formTitle }}</h2>

            <nx-content-selector
              :allow-non-published="allowNonPublished"
              :label="$t('message.block.form.live.search')"
              :type="['live']"
              :value="live"
              @input="updateSelectedLive"
            ></nx-content-selector>

            <v-text-field
              :label="$t('message.block.form.live.label')"
              v-model="data.title"
            ></v-text-field>

          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </nx-fullscreen-dialog>
</template>

<script>
import axios from 'axios';
import ContentSelector from '@/modules/content/selector/Selector';
import DialogButton from './DialogButton';
import api from '@/modules/content/search/api';

/**
 * LiveButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-live-button',
  extends: DialogButton,
  components: {
    [ContentSelector.name]: ContentSelector,
  },
  props: {
    embedId: String,
    embedTitle: String,
    allowNonPublished: Boolean,
  },
  data() {
    return {
      name: 'liveEmbed',
      data: {
        id: this.embedId || '',
        title: this.embedTitle || '',
      },
      live: null,
    };
  },
  computed: {
    liveTitle() {
      return this.$t('message.block.form.live.title');
    },
    placeholderTitle() {
      return this.$t('message.block.form.live.placeholder');
    },
    isValid() {
      return !!this.live;
    },
  },
  methods: {
    updateSelectedLive(live) {
      console.log(live);
      this.live = live;
      this.data.id = live.id;
      this.data.title = live.title;
    },
    async fetchLive() {
      this.live = await api.getContent({ type: 'live', id: this.data.id });
    },
  },
  mounted() {
    this.data = {
      title: this.embedTitle || '',
      id: this.embedId || '',
      thumbnail: this.embedThumbnail || '',
    };
    console.log(this.embedId);
    if (this.embedId) this.fetchLive();
  },
};
</script>
